<template>
  <div class="main-custom">
    <Header />
    <section class="container mb-30">
      <div id="description">
        <h1 class="title has-text-centered has-text-color-7">
          {{ Home.PageNotFoundScreen.TITLE }}
        </h1>
        <h2
          class="subtitle is-size-4 has-text-weight-medium has-text-centered has-text-color-7 mt-0"
        >
          {{ Home.PageNotFoundScreen.SUBTITLE }}
        </h2>
        <b-button
          class="has-text-weight-bold is-uppercase px-100"
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          size="is-medium"
          @click="goToRoot"
          ><span class="is-size-7">{{ Home.HOME }}</span></b-button
        >
      </div>
    </section>
    <Footer :isReduced="true" />
  </div>
</template>

<script>
import { Home } from "@/utils/constants";
import Header from "@/layout/Header";
import Footer from "@/layout/Footer";
import { mapGetters } from "vuex";

export default {
  name: "PageNotFound",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      Home
    };
  },
  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },
  methods: {
    goToRoot() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 0;

  #description {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 23rem 20% 0;

    @media screen and (max-width: $tablet) {
      padding: 23rem 10% 0;
    }
  }

  &::before {
    content: "404";
    position: absolute;
    text-align: center;
    font-size: 25rem;
    font-weight: 700;
    color: $color-25;
    z-index: -1;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }
}
</style>
